// Material-ui
import { Typography } from "@mui/material";

// Project Imports
import NavGroup from "./NavGroup";
import getMenuItem from "menu-items";

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = (currentPerms) => {
  const menuItem = getMenuItem(currentPerms);

  const navItems = menuItem.items.map((item) => {
    switch (item.type) {
      case "group":
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default MenuList;
